export default function WinterHeroSection() {
  return (
    <div className="w-full bg-black text-white py-24 px-6 md:px-12 lg:px-24">
      <div className="max-w-4xl mx-auto text-center">
        {/* Title with subtle animation */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-8 leading-tight">
          WINTER ESSENTIALS
        </h1>
        
        {/* Decorative line */}
        <div className="w-20 h-0.5 bg-white mb-8 mx-auto"></div>
        
        {/* Description paragraph */}
        <p className="text-lg md:text-md lg:text-xl leading-relaxed text-gray-300 font-light max-w-3xl mx-auto">
          An oversized hoodie that's more than just cozy—it's essential. Designed with premium materials and a perfectly relaxed fit, our winter collection brings together warmth, comfort, and understated style. For those who know that the best pieces are the ones you reach for every day.
        </p>
        
        {/* Optional CTA Button */}
        <div className="mt-12">
          <button className="px-8 py-4 bg-white text-black rounded-md font-semibold tracking-wide hover:bg-gray-200 transition-colors duration-300 uppercase text-sm">
            Shop Collection
          </button>
        </div>
      </div>
    </div>
  );
}
